import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import AutoAllocateAllButton
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/AutoAllocateAllButton/Content';
import {
  AutoAllocateAllProvider,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/AutoAllocateAllButton/Content/AutoAllocateAllContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
  },
  rootHidden: {
    display: 'none',
  },
});

const AutoAllocationAllButton = ({
  className, classes, autoAllocateUrl, hidden,
}) => {
  const { refreshPageContentCollection } = usePageContentContext();
  return (
    <Box className={classNames(classes.root, {
      [classes.rootHidden]: hidden,
      className,
    })}
    >
      <AutoAllocateAllProvider allocateUrl={autoAllocateUrl}>
        <AutoAllocateAllButton
          onSuccess={refreshPageContentCollection}
          dialogProps={{
            title: 'Warning',
            message: 'This action will automatically update all allocations across all outcomes to the recommended allocations. Any existing allocations will be replaced.',
            confirmLabel: 'Allocate',
            cancelLabel: 'Nevermind',
          }}
        />
      </AutoAllocateAllProvider>
    </Box>
  );
};

AutoAllocationAllButton.defaultProps = {
  className: '',
  hidden: false,
};

AutoAllocationAllButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  autoAllocateUrl: PropTypes.string.isRequired,
  hidden: PropTypes.bool,
};

export default withStyles(styles)(AutoAllocationAllButton);
